import MessageInput from "./MessageInput";

type TCategoryChatViewProps = {
  title: string;
  description?: string;
  tags?: string[];
};

export default function CategoryChatView({
  title,
  description,
  tags = ["Product", "Operations", "Go-To-Market", "Team", "Materials", "Finance", "Structure"],
}: TCategoryChatViewProps) {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex-1 overflow-y-auto p-6">
        <div className="mb-6 rounded-xl border bg-card p-5">
          <div className="flex items-center gap-2 font-semibold text-foreground">
            <span className="inline-block h-2 w-2 rounded-full bg-muted-foreground" />
            <span>{title}</span>
          </div>
          {description && <p className="mt-3 text-sm text-muted-foreground">{description}</p>}
        </div>

        {/* Message input section (second block) */}
        <div className="mb-6 rounded-xl border bg-card p-3">
          <MessageInput />
        </div>

        <div className="mb-6 rounded-xl border bg-card p-4">
          <div className="flex flex-wrap gap-3">
            {tags.map((tag) => (
              <button
                key={tag}
                className="rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-xs text-primary hover:bg-primary/20"
                type="button"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="rounded-xl border bg-card p-5">
          <div className="mb-2 text-xs uppercase text-muted-foreground">Pitch Deck</div>
          <div className="mb-2 text-sm text-foreground">Feedback:</div>
          <p className="text-sm text-muted-foreground">
            This is a placeholder area for category-specific insights, checklists and resources.
          </p>
        </div>
      </div>
    </div>
  );
}
